import React from 'react'

const THCSeltzerRedTemplate = (props) => {
    console.log(props)
    let seltzerBevs = props.seltzerMenu.items
    let thcBevs = props.thcMenu.items
    let redWine = props.redWine.items
    console.log(seltzerBevs)
    return(
        <div className="seltzer-red-page">
            <div className="background-image">
                <div className="col-left">
                    <div className="seltzer-drinks-left">
                      {seltzerBevs 

                      ? 
                      <>
                        {seltzerBevs.map((item, ct) => (
                             <div key={ct} className="thc-item">
                                <div className="seltzer-name">
                                    {item.name}
                                </div>
                                <div className="seltzer-description">
                                    {item.description}
                                </div>
                                <div className="seltzer-price">
                                    {item.containers[0].name} • {item.containers[0].price}
                                </div>
                             </div>   
                                
                              
                        ))}
                      </>
                    
                      :
                      <>loading...</>
                      }
                    </div>
                    <div className="thc-drinks-left">
                        {thcBevs
                            ?
                            <>
                                {thcBevs.map((item, ct) => (
                                    <div key={ct} className="thc-item">
                                    <div className="seltzer-name">
                                        {item.name}
                                    </div>
                                    <div className="seltzer-description">
                                        {item.description}
                                    </div>
                                    <div className="seltzer-price">
                                        {item.containers[0].name} • {item.containers[0].price}
                                    </div>
                                 </div>   
                                ))}
                            </>
                            :
                            <>loading...</>
                        }
                    </div>
                </div>
                <div className="col-right-redwine">
                    <div className="wine-drinks-right">
                        {redWine
                            ?
                            <>
                            {redWine.map((item, ct) => (
                                <div key={ct} className="thc-item">
                                    <div className="seltzer-name">
                                        {item.name}
                                    </div>
                                    <div className="seltzer-description">
                                        {item.description}
                                    </div>
                                    <div className="seltzer-price">
                                        {item.containers[0].name} • {item.containers[0].price}
                                    </div>
                                </div>   
                            ))}
                            </>
                            :
                            <>loading...</>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default THCSeltzerRedTemplate


/*

 <div className="thc-item">
                                    <div className="thc-name">
                                        {item.vendor}
                                    </div>
                                </div>

*/